import axios from 'axios';
import store from '@/store';
import { API_TWITTER_OAUTH1_ENDPOINT } from '.';

export async function requestTwitterLoginUrl(scope) {
  console.debug('oauth1.requestTwitterLoginUrl()');

  if (!scope || !Array.isArray(scope) || scope.length === 0) {
    throw new Error('scope malformated on client request');
  }
  const data = {
    scope,
  };

  const ep_url = API_TWITTER_OAUTH1_ENDPOINT + '/link';
  console.debug(' ... ep_url:', ep_url);

  try {
    const access_token = store.state.idToken;
    console.debug('oauth1.requestTwitterLoginUrl(): access_token', access_token);
    let response = await axios.post(ep_url, data);
    return response.data;
  } catch (error) {
    console.debug(' ... oauth1.requestTwitterLoginUrl():', ep_url, `error:`, error);
    throw error;
  }
}

export async function generateAccessTokenAndLogin(oauth_token, oauth_verifier) {
  if (!oauth_token) {
    throw new Error('Twitter oauth_token required');
  }
  if (!oauth_verifier) {
    throw new Error('Twitter oauth_verifier required');
  }
  return new Promise((resolve, reject) => {
    const data = {
      oauth_token,
      oauth_verifier,
    };

    fetch(`${API_TWITTER_OAUTH1_ENDPOINT}/callback`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then(data => resolve(data))
      .catch(error => {
        reject(error);
      });
  });
}

export async function getUserData(accessToken) {
  if (!accessToken) {
    throw new Error('accessToken required');
  }

  return new Promise((resolve, reject) => {
    fetch(`${API_TWITTER_OAUTH1_ENDPOINT}/user`, {
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then(data => resolve(data))
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * Create a tweet
 * @param accessToken
 * @returns
 */
export async function createTweet(accessToken, message, imageUrl) {
  if (!accessToken) {
    throw new Error('Twitter accessToken required');
  }
  if (!message) {
    throw new Error('Message required');
  }

  return new Promise((resolve, reject) => {
    const data = {
      message,
      imageUrl,
      accessToken,
    };

    fetch(`${API_TWITTER_OAUTH1_ENDPOINT}/tweet`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then(data => resolve(data))
      .catch(error => {
        reject(error);
      });
  });
}

export default {
  requestTwitterLoginUrl,
  generateAccessTokenAndLogin,
  createTweet,
};
